import React from 'react';
import { HasNameAndCode } from 'src/types/shared';
import { FunctionComponentProps, FunctionComponentReturnType } from 'src/types/sharedReact';
import Icon from 'src/components/icons/Icon/Icon';
import analyticsIcon from 'src/assets/images/AnalyticsIcon.png';
import 'src/components/SelectableCard/CardLogo.css';

interface CardLogoProps extends FunctionComponentProps {
    item: HasNameAndCode;
    defaultIconType: string;
    imageUrl?: string | null;
}

function loadLogo(code: string): string | null {
  let logo = null;
  try {
    logo = require(`../../assets/images/logos/${code}.svg`).default;
  } catch (e) {}

  if (!logo)
    try {
      logo = require(`../../assets/images/logos/${code}.png`).default;
    } catch (e) {}
  return logo;
}

function getLogo(code: string): { logo: string | null; needsWhiteBackground: boolean } {
  const isDevEx = window.location.hostname.includes('developer') || window.location.hostname.includes('localhost');

  if (isDevEx) {
    const whiteLogo = loadLogo(code + '_WHITE');
    if (whiteLogo) {
      return { logo: whiteLogo, needsWhiteBackground: false };
    }
    const regularLogo = loadLogo(code);
    if (regularLogo) {
      return { logo: regularLogo, needsWhiteBackground: true };
    }
    return { logo: analyticsIcon, needsWhiteBackground: true };
  }

  return { logo: loadLogo(code), needsWhiteBackground: false };
}

function CardLogo({ item, defaultIconType, imageUrl }: CardLogoProps): FunctionComponentReturnType {
    const { logo: resolvedLogo, needsWhiteBackground } = getLogo(item.code);
    const logo: string | null = imageUrl || resolvedLogo;
    const isDefaultLogo = !imageUrl && (!resolvedLogo || resolvedLogo === analyticsIcon);
    return (
        <div className={`card-logo-wrapper${isDefaultLogo ? ' card-logo-wrapper--default' : ''}`}>
            {isDefaultLogo ? (
                <span className="card-logo-default-name" aria-hidden="true">
                    {item.name.replace(/-/g, ' ')}
                </span>
            ) : logo ? (
                <img
                    className={`card-logo${needsWhiteBackground ? ' card-logo--white-bg' : ''}`}
                    src={logo}
                    alt=""
                    role="presentation"
                />
            ) : (
                <Icon
                    className="card-logo-placeholder"
                    type={defaultIconType}
                />
            )}
        </div>
    );
}

export default CardLogo;
